<template>
  <div>
    <v-container>
      <base-material-card
        icon="mdi-clipboard-text"
        title="ผลการประเมินการปฏิบัติงานย้อนหลัง"
        class="px-5 py-3"
      >
        <v-card class="mb-4 pa-2">
          <v-row>
            <v-col cols="12" md="6" class="text-right">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
                single-line
                hide-details
                dense
                filled
                class="mb-2"
              />
            </v-col>
            <v-col cols="12" md="6" class="text-right">
              <v-btn
                large
                right
                depressed
                color="primary"
                @click.native="personnel_govem_assesmentAdd()"
              >
                <v-icon>mdi-plus-circle-outline</v-icon>เพิ่มรายการ
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-data-table
          color="success"
          :loading="loading"
          :headers="headers"
          :items="personnel_govem_assesments"
          :search="search"
        >
         
          <template v-slot:item.actions="{ item }">
            <v-icon
              color="yellow"
              @click.stop="personnel_govem_assesmentEdit(item.personnel_govem_assesmentid)"
            >
              mdi-pencil
            </v-icon>
          </template>

          <template v-slot:item.action_s="{ item }">
            <v-icon
              color="red"
              @click.stop="personnel_govem_assesmentDelete(item.personnel_govem_assesmentid)"
            >
              mdi-delete
            </v-icon>
          </template>

          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
            >ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.</v-alert
          >
        </v-data-table>
      </base-material-card>

      <!--addpersonnel_govem_assesmentdialog  -->
      <v-layout row justify-center>
        <v-dialog
          v-model="addpersonnel_govem_assesmentdialog"
          persistent
          max-width="50%"
          overlay-opacity="0.6"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              icon="mdi-clipboard-text"
              title="เพิ่มข้อมูล"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text class="text_google">
              <v-form ref="addpersonnel_govem_assesmentform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="
                              addpersonnel_govem_assesment.govem_assesment_timeyear
                            "
                            label="ครั้งที่ : 1/2568"
                            request
                            persistent-hint
                            :rules="advancedRules"
                            clearable
                            maxlength="7"
                            rounded
                            outlined
                            prepend-icon="mdi-calendar"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            v-model="
                              addpersonnel_govem_assesment.govem_assesment_level
                            "
                            :items="govem_assesment_levelselect"
                            item-text="text"
                            item-value="value"
                            label="ระดับ : "
                            request
                            :rules="[v => !!v || '']"
                            rounded
                            outlined
                            prepend-icon="mdi-source-branch"
                          ></v-select>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="
                              addpersonnel_govem_assesment.govem_assesment_score
                            "
                            label="คะแนน : "
                            request
                            :rules="[v => !!v || '']"
                            rounded
                            outlined
                            type="number"
                            maxlength="3"
                            prepend-icon="mdi-flag-variant"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="
                                  addpersonnel_govem_assesment.personnel_govem_assesment_dateitem
                                "
                                label="วันที่ประเมิน : วันที่ตามแบบฟอร์ม 1-3"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                rounded
                                outlined
                                 :rules="[v => !!v || '']"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="
                                addpersonnel_govem_assesment.personnel_govem_assesment_dateitem
                              "
                              no-title
                              scrollable
                              locale="TH-th"
                              
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-flex>
                  </v-layout>
                  <v-spacer></v-spacer>
                  <v-row>
                    <v-col cols="12">
                      
                     
                      <div class="red--text font-weight-bold">
                        * วันที่ประเมิน ครั้งที่ 1 ไม่ก่อนวันที่ 31 มีนาคม 
                      </div>
                       <div class="red--text font-weight-bold">
                        * วันที่ประเมิน ครั้งที่ 2 ไม่ก่อนวันที่ 30 กันยายน
                      </div>
                    </v-col>
                    <v-col cols="12" md="12" class="text-right">
                     
                      <v-btn
                        large
                        color="warning"
                        @click.stop="addpersonnel_govem_assesmentdialog = false"
                        rounded
                      >
                        <v-icon dark>mdi-close</v-icon>ยกเลิก
                      </v-btn>


                       <v-btn
                        large
                        color="success"
                        @click.stop="addpersonnel_govem_assesmentSubmit()"
                        rounded
                      >
                        <v-icon dark>mdi-content-save</v-icon
                        >&nbsp;&nbsp;บันทึก</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model deletepersonnel_govem_assesmentdialog -->
      <v-layout>
        <v-dialog
          v-model="deletepersonnel_govem_assesmentdialog"
          persistent
          max-width="40%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="error"
              icon="mdi-delete"
              title="ลบข้อมูล"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text class="text_google">
              <v-form ref="deletepersonnel_govem_assesmentform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      ยืนยันการลบข้อมูล :
                      <h3>{{ editpersonnel_govem_assesment.user_firstname }} ครั้งที่ {{ editpersonnel_govem_assesment.govem_assesment_timeyear }}</h3>
                    </v-flex>
                    <v-flex xs12 md6></v-flex>
                    <v-flex xs12 md6></v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                large
                @click.stop="deletepersonnel_govem_assesmentdialog = false"
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="red darken-3"
                @click.stop="deletepersonnel_govem_assesmentubmit()"
                dark
              >
                <v-icon dark>mdi-delete</v-icon>&nbsp;ลบ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model editpersonnel_govem_assesmentdialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="editpersonnel_govem_assesmentdialog"
          persistent
          max-width="50%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="yellow"
              icon="mdi-clipboard-text"
              title="แก้ไขข้อมูลการศึกษา"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="editpersonnel_govem_assesmentform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12>
                        <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="
                              editpersonnel_govem_assesment.govem_assesment_timeyear
                            "
                            label="ครั้งที่ : 1/2568"
                            request
                            persistent-hint
                            :rules="advancedRules"
                            clearable
                            maxlength="7"
                            rounded
                            outlined
                            prepend-icon="mdi-calendar"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            v-model="
                              editpersonnel_govem_assesment.govem_assesment_level
                            "
                            :items="govem_assesment_levelselect"
                            item-text="text"
                            item-value="value"
                            label="ระดับ : "
                            request
                            :rules="[v => !!v || '']"
                            rounded
                            outlined
                            prepend-icon="mdi-source-branch"
                          ></v-select>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="
                              editpersonnel_govem_assesment.govem_assesment_score
                            "
                            label="คะแนน : "
                            request
                            :rules="[v => !!v || '']"
                            rounded
                            outlined
                            type="number"
                            maxlength="3"
                            prepend-icon="mdi-flag-variant"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="
                                  editpersonnel_govem_assesment.personnel_govem_assesment_dateitem
                                "
                                label="วันที่ประเมิน"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                rounded
                                outlined
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="
                                editpersonnel_govem_assesment.personnel_govem_assesment_dateitem
                              "
                              no-title
                              scrollable
                              locale="TH-th"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>                    
                      </v-row>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                large
                @click.stop="editpersonnel_govem_assesmentdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="warning"
                @click.stop="editpersonnel_govem_assesmentSubmit()"
                rounded
              >
                <v-icon dark>mdi-pencil</v-icon>&nbsp;แก้ไขข้อมูล
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        multi-line
        vertical
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <br />
        {{ snackbar.text }}
        <v-btn dark @click="snackbar.show = false">Close</v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: true,
      updateImageDialog: false,
      search: "",
      addpersonnel_govem_assesmentdialog: false,
      editpersonnel_govem_assesmentdialog: false,
      deletepersonnel_govem_assesmentdialog: false,
      showimagedialog: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      currentPK: null,
      headers: [      
        {
          text: "สถานศึกษา",
          align: "center",
          value: "user_firstname"
        },
        {
          text: "ครั้ง/ปี",
          align: "center",
          value: "govem_assesment_timeyear"
        },
        { text: "ระดับ", align: "center", value: "govem_assesment_level" },
        { text: "คะแนน", align: "left", value: "govem_assesment_score" },
        {
          text: "วันที่ประเมิน",
          align: "center",
          value: "personnel_govem_assesment_dateitem"
        },

        {
          text: "แก้ไข",
          align: "center",
          value: "actions",
          icon: "mdi-file-document-edit"
        },
        {
          text: "ลบ",
          align: "center",
          value: "action_s",
          icon: "mdi-delete-forever"
        }
      ],
      rowsperpage: [
        25,
        50,
        100,
        {
          text: "All",
          value: -1
        }
      ],
      pagination: {},
      personnel_govem_assesment: [],
      addpersonnel_govem_assesment: {},
      editpersonnel_govem_assesment: [],
      personnel_govem_assesments: [],
      personnel_govem_assesment_sub: [],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      govem_assesment_levelselect: [
        { text: "ดีเด่น", value: "ดีเด่น" },
        { text: "ดีมาก", value: "ดีมาก" },
        { text: "ดี", value: "ดี" },
        { text: "พอใช้", value: "พอใช้" },
        { text: "ต้องปรับปรุง", value: "ต้องปรับปรุง" }
      ],
      advancedRules: [
        v => !!v || "กรุณากรอกข้อมูล",
        v => {
          if (!v) return true;
          const pattern = /^\d{1,2}\/\d{4}$/;
          return (
            pattern.test(v) ||
            "รูปแบบไม่ถูกต้อง ใช้รูปแบบ ครั้งที่/ปี พ.ศ. (เช่น 1/2568)"
          );
        },
        v => {
          if (!v) return true;
          const parts = v.split("/");
          if (parts.length !== 2) return "รูปแบบไม่ถูกต้อง";

          const time = parseInt(parts[0]);
          const year = parseInt(parts[1]);

          if (isNaN(time) || isNaN(year)) return "กรุณากรอกตัวเลขเท่านั้น";
          if (time < 1 || time > 4) return "ครั้งที่ต้องอยู่ระหว่าง 1-4";
          if (year < 2560 || year > 2570)
            return "ปี พ.ศ. ต้องอยู่ระหว่าง 2560-2570";

          return true;
        },
        v => {
          if (!v) return true;
          const currentYear = new Date().getFullYear() + 543; // แปลงเป็น พ.ศ.
          const parts = v.split("/");
          const inputYear = parseInt(parts[1]);

          if (inputYear > currentYear)
            return `ปี พ.ศ. ไม่สามารถมากกว่าปีปัจจุบัน (${currentYear}) ได้`;

          return true;
        }
      ]
    };
  },

  async mounted() {
    this.personnel_govem_assesmentsQueryAll();
  },

  methods: {
    formatInput() {
      let value = this.addpersonnel_govem_assesment.govem_assesment_timeyear;
      if (!value) return;

      // ลบอักขระที่ไม่ใช่ตัวเลขและ /
      value = value.replace(/[^\d\/]/g, "");

      // ถ้ามีตัวเลข 1-2 หลักแล้วไม่มี / ให้เพิ่ม / อัตโนมัติ
      if (/^\d{1,2}$/.test(value) && value.length >= 1) {
        // ไม่ทำอะไร ให้ผู้ใช้พิมพ์ / เอง
      }

      // ถ้ามี / แล้วให้จำกัดรูปแบบ
      if (value.includes("/")) {
        const parts = value.split("/");
        if (parts.length > 2) {
          value = parts[0] + "/" + parts[1];
        }

        // จำกัดครั้งที่ไม่เกิน 2 หลัก
        if (parts[0] && parts[0].length > 2) {
          parts[0] = parts[0].substring(0, 2);
        }

        // จำกัดปีไม่เกิน 4 หลัก
        if (parts[1] && parts[1].length > 4) {
          parts[1] = parts[1].substring(0, 4);
        }

        value = parts.filter(p => p !== "").join("/");
      }

      this.addpersonnel_govem_assesment.govem_assesment_timeyear = value;
    },
    async personnel_govem_assesmentsQueryAll() {
      this.loading = true;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
 
      let result = await this.$http
        .post("personnel_govem_assesment.php", {
          ApiKey: this.ApiKey,
          personnel_govem_assesment_idcard: userSession.id_card
        })
        .finally(() => (this.loading = false));
      this.personnel_govem_assesments = result.data;
    },
    //Add data
    async personnel_govem_assesmentAdd() {
      this.addpersonnel_govem_assesment = {};
      this.addpersonnel_govem_assesmentdialog = true;
    },

    async addpersonnel_govem_assesmentSubmit() {
      if (this.$refs.addpersonnel_govem_assesmentform.validate()) {
        let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
        this.addpersonnel_govem_assesment.ApiKey = this.ApiKey;
        this.addpersonnel_govem_assesment.personnel_govem_assesment_idcard =
          userSession.id_card;
        this.addpersonnel_govem_assesment.personnel_govem_assesment_collegeid =
          userSession.college_code;

        let result = await this.$http.post(
          "personnel_govem_assesment.insert.php",
          this.addpersonnel_govem_assesment
        );
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.personnel_govem_assesmentsQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.addpersonnel_govem_assesmentdialog = false;
      }
    },

    //Edit data
    async personnel_govem_assesmentEdit(personnel_govem_assesmentid) {
      let result = await this.$http.post("personnel_govem_assesment.php", {
        ApiKey: this.ApiKey,
        personnel_govem_assesmentid: personnel_govem_assesmentid
      });
      this.editpersonnel_govem_assesment = result.data;
      this.editpersonnel_govem_assesmentdialog = true;
    },

    async editpersonnel_govem_assesmentSubmit() {
      if (this.$refs.editpersonnel_govem_assesmentform.validate()) {
        this.editpersonnel_govem_assesment.ApiKey = this.ApiKey;
        let result = await this.$http.post(
          "personnel_govem_assesment.update.php",
          this.editpersonnel_govem_assesment
        );
        if (result.data.status == true) {
          this.personnel_govem_assesment = result.data;
          Swal.fire({
            icon: "success",
            title: "แก้ไขข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.personnel_govem_assesmentsQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "แก้ไขข้อมูลผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.editpersonnel_govem_assesmentdialog = false;
      }
    },

    //DELETE data
    async personnel_govem_assesmentDelete(personnel_govem_assesmentid) {
      let result = await this.$http.post("personnel_govem_assesment.php", {
        ApiKey: this.ApiKey,
        personnel_govem_assesmentid: personnel_govem_assesmentid
      });
      this.editpersonnel_govem_assesment = result.data;
      this.deletepersonnel_govem_assesmentdialog = true;
    },

    async deletepersonnel_govem_assesmentubmit() {
      if (this.$refs.deletepersonnel_govem_assesmentform.validate())
        this.editpersonnel_govem_assesment.ApiKey = this.ApiKey;
      {
        let result = await this.$http.post(
          "personnel_govem_assesment.delete.php",
          this.editpersonnel_govem_assesment
        );
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ลบข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.personnel_govem_assesmentsQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ลบข้อมูลผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.deletepersonnel_govem_assesmentdialog = false;
      }
    }
  },

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  }
};
</script>
<style>
.v-data-table thead th {
  font-size: 16px !important;
}
</style>
